/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
	const { nodes, materials } = useGLTF("models/RecycledNylon.glb");
	return (
		<group {...props} dispose={null}>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube019.geometry}
				material={materials["recycle.001"]}
				position={[-0.002, 0.363, -0.078]}
				scale={[1.106, 0.411, 1.106]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube012.geometry}
				material={materials["Plain Purple Flat.001"]}
				position={[0.333, 0.017, 0.305]}
				rotation={[2.851, 1.415, -2.492]}
				scale={[1.44, 1.44, 0.199]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube011.geometry}
				material={materials["Plain Green Flat.001"]}
				position={[0.277, 0.037, 0.403]}
				rotation={[0, 1.38, 0.347]}
				scale={[1.44, 1.44, 0.199]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube010.geometry}
				material={materials["Plain Red Texture.001"]}
				position={[0.142, 0.154, 0.524]}
				rotation={[0, 1.15, 0.305]}
				scale={[1.44, 1.44, 0.199]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube009.geometry}
				material={materials["Plain Brown Flat.001"]}
				position={[-0.147, 0.141, 0.524]}
				rotation={[0, 0.824, 0.305]}
				scale={[1.44, 1.44, 0.199]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube008.geometry}
				material={materials["Plain Pink Texture.001"]}
				position={[-0.442, 0.124, 0.524]}
				rotation={[0, 0.529, 0.305]}
				scale={[1.44, 1.44, 0.199]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube007.geometry}
				material={materials["Fabric Cortadito Raven.001"]}
				position={[-0.714, 0.114, 0.524]}
				rotation={[0, 0.263, 0.305]}
				scale={[1.44, 1.44, 0.199]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube006.geometry}
				material={materials["Snooker Pool Table Cloth.001"]}
				position={[-1.03, 0.094, 0.524]}
				rotation={[0, 0, 0.307]}
				scale={[1.44, 1.44, 0.199]}
			/>
		</group>
	);
}

useGLTF.preload("models/RecycledNylon.glb");
